import notificationsApi from './notificationsApi';

class NotificationsService {
  /**
   * Obter notificações do usuário (com fallback seguro)
   */
  async getNotifications(skip = 0, take = 20) {
    try {
      const response = await notificationsApi.get('/Notifications', {
        params: { skip, take }
      });
      return response.data || [];
    } catch (error) {
      console.warn('[Notifications] Failed to fetch notifications:', error.message);
      return []; // Retorna array vazio em caso de erro
    }
  }

  /**
   * Obter contador de notificações não lidas
   */
  async getUnreadCount() {
    try {
      const response = await notificationsApi.get('/Notifications/unread/count');
      return response.data?.count || 0;
    } catch (error) {
      console.warn('[Notifications] Failed to fetch unread count:', error.message);
      return 0; // Retorna 0 em caso de erro
    }
  }

  /**
   * Marcar notificação como lida
   */
  async markAsRead(notificationId) {
    try {
      await notificationsApi.patch(`/Notifications/${notificationId}/read`);
      return true;
    } catch (error) {
      console.warn('[Notifications] Failed to mark as read:', error.message);
      return false;
    }
  }

  /**
   * Deletar notificação
   */
  async deleteNotification(notificationId) {
    try {
      await notificationsApi.delete(`/Notifications/${notificationId}`);
      return true;
    } catch (error) {
      console.warn('[Notifications] Failed to delete notification:', error.message);
      return false;
    }
  }
}

export const notificationsService = new NotificationsService();
